import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';
import './ConfigPopVideo.css';

const ConfigPopVideo = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [config, setConfig] = useState({
    video1_ativo: false,
    video1_url: '',
    video2_ativo: false,
    video2_url: ''
  });

  useEffect(() => {
    if (isOpen) {
      fetchConfig();
    }
  }, [isOpen]);

  const fetchConfig = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/pop-video/config`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data) {
        setConfig({
          video1_ativo: response.data.video1_ativo || false,
          video1_url: response.data.video1_url || '',
          video2_ativo: response.data.video2_ativo || false,
          video2_url: response.data.video2_url || ''
        });
      }
    } catch (error) {
      console.error('Erro ao buscar configurações de vídeo:', error);
      setMessage({ type: 'error', text: 'Erro ao carregar configurações' });
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage({ type: '', text: '' });
    try {
      const token = localStorage.getItem('token');
      console.log('[ConfigPopVideo] Enviando dados para salvar:', config);
      console.log('[ConfigPopVideo] URL da API:', `${API_URL}/api/pop-video/config`);
      const response = await axios.post(
        `${API_URL}/api/pop-video/config`,
        config,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      console.log('[ConfigPopVideo] Resposta do servidor:', response.data);
      if (response.data && (response.data.ok === true || response.status === 200)) {
        setMessage({ type: 'success', text: response.data.message || 'Configurações salvas com sucesso!' });
        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        throw new Error('Resposta inesperada do servidor');
      }
    } catch (error) {
      console.error('[ConfigPopVideo] Erro ao salvar configurações:', error);
      console.error('[ConfigPopVideo] Detalhes do erro:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        statusText: error.response?.statusText
      });
      const errorMessage = error.response?.data?.error ||
                          error.response?.data?.message ||
                          error.message ||
                          'Erro ao salvar configurações';
      setMessage({ type: 'error', text: errorMessage });
    } finally {
      setSaving(false);
    }
  };

  const toggleAtivo = (field) => {
    setConfig(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content config-pop-video" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Configurações de Vídeos Pop-up</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="loading">Carregando configurações...</div>
          ) : (
            <>
              {message.text && (
                <div className={`message ${message.type}`}>{message.text}</div>
              )}

              <div className="info-box">
                <p><strong>Vídeo 1:</strong> Será exibido imediatamente após o login (15 segundos)</p>
                <p><strong>Vídeo 2:</strong> Será exibido após 15 minutos do login (15 segundos)</p>
              </div>

              <div className="config-item">
                <div className="config-item-header">
                  <label className="config-label">Vídeo 1</label>
                  <button
                    className={`toggle-button ${config.video1_ativo ? 'ativo' : 'inativo'}`}
                    onClick={() => toggleAtivo('video1_ativo')}
                  >
                    {config.video1_ativo ? 'Ativo' : 'Inativo'}
                  </button>
                </div>
                <input
                  type="url"
                  className="config-input"
                  placeholder="https://www.youtube.com/embed/VIDEO_ID"
                  value={config.video1_url}
                  onChange={(e) => setConfig({ ...config, video1_url: e.target.value })}
                />
                <span className="config-hint">URL do vídeo (YouTube, Vimeo, etc.)</span>
              </div>

              <div className="config-item">
                <div className="config-item-header">
                  <label className="config-label">Vídeo 2</label>
                  <button
                    className={`toggle-button ${config.video2_ativo ? 'ativo' : 'inativo'}`}
                    onClick={() => toggleAtivo('video2_ativo')}
                  >
                    {config.video2_ativo ? 'Ativo' : 'Inativo'}
                  </button>
                </div>
                <input
                  type="url"
                  className="config-input"
                  placeholder="https://www.youtube.com/embed/VIDEO_ID"
                  value={config.video2_url}
                  onChange={(e) => setConfig({ ...config, video2_url: e.target.value })}
                />
                <span className="config-hint">URL do vídeo (YouTube, Vimeo, etc.)</span>
              </div>
            </>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>Cancelar</button>
          <button className="btn-save" onClick={handleSave} disabled={saving || loading}>
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfigPopVideo;
